import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, radii } = theme

export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  flex: 1 1 100%;
  min-width: 0;
  aspect-ratio: 5 / 8;
  overflow: hidden;
  border-radius: ${radii['corner-radius-md']};

  @media (${media.phone}) {
    flex: none;
    width: 80vw;
  }

  @media (${media.tablet}) {
    flex: 1 1 0;
  }
`
